// Moet gelijk blijven aan de PasswordPolicy op de UserPool in template.yaml.
// Stond eerder op drie plekken los uitgeschreven, waarvan één met 8 in plaats
// van 12: die melding beloofde iets wat Cognito daarna weigerde.
export const PASSWORD_MIN_LENGTH = 12;

export const PASSWORD_RULE_TEXT = `Minimaal ${PASSWORD_MIN_LENGTH} tekens, met hoofd- en kleine letters en een cijfer.`;

export const PASSWORD_REJECTED_TEXT =
  `Het wachtwoord voldoet niet aan de eisen. Gebruik minimaal ${PASSWORD_MIN_LENGTH} tekens, ` +
  `met hoofdletters, kleine letters en cijfers.`;
